export var Severity;
(function (Severity) {
    Severity[Severity["RECOVERABLE"] = 10] = "RECOVERABLE";
    Severity[Severity["WARNING"] = 20] = "WARNING";
    Severity[Severity["ERROR"] = 30] = "ERROR";
    Severity[Severity["FATAL"] = 40] = "FATAL";
})(Severity || (Severity = {}));
//# sourceMappingURL=error-logger.types.js.map